const Loader = () => {
  const BAR_COUNT = 5;
  return (
    <div
      className="absolute inset-0 z-50 w-full h-full
        flex items-center justify-center
        bg-white/50"
    >
      <div className="wave-loader" role="status" aria-label="Loading">
        {Array.from({ length: BAR_COUNT }).map((_, i) => (
          <span key={i} style={{ animationDelay: `${i * 0.12}s` }} />
        ))}
      </div>
    </div>
  );
};

export default Loader;
